// Generic completion_source vocabulary. Every completion written from onward-web is WEB —
// the role of the user who completed it is not encoded here. INTEGRATIONS and MOBILE are
// written by their own surfaces and are listed for reference.
export const COMPLETION_SOURCES = {
    WEB: 'WEB',
    INTEGRATIONS: 'INTEGRATIONS',
    MOBILE: 'MOBILE',
};
